// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	jQ(window).scroll(function(){
        if (jQ('#HeaderWrapper').length > 0) {
            if (jQ('#HeaderWrapper').hasClass('header-wrapper--compressed')) {
                jQ('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open').css('top', jQ('#HeaderWrapper').height());
            } else {
                jQ('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open').css('top', jQ('#HeaderWrapper').height() + 33);
            }
        }
    });
	
})();